var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAlarm3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 16,
    width: 56,
    height: 56,
    rx: 8,
    fill: "#FFE500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3337 39.3333V62.6667C51.3337 63.2855 51.0878 63.879 50.6502 64.3166C50.2127 64.7542 49.6192 65 49.0003 65H7.00033C6.38149 65 5.78799 64.7542 5.35041 64.3166C4.91282 63.879 4.66699 63.2855 4.66699 62.6667V39.3333H51.3337ZM51.3337 34.6667H4.66699V25.3333C4.66699 24.7145 4.91282 24.121 5.35041 23.6834C5.78799 23.2458 6.38149 23 7.00033 23H49.0003C49.6192 23 50.2127 23.2458 50.6502 23.6834C51.0878 24.121 51.3337 24.7145 51.3337 25.3333V34.6667ZM35.0003 53.3333V58H44.3337V53.3333H35.0003Z",
    fill: "#FFE600"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarm3);
export default __webpack_public_path__ + "static/media/Icon_Alarm-3.18df857e1a773b1c5f95865d4158b845.svg";
export { ForwardRef as ReactComponent };